import React from "react";
import './square.css';

class Square extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            wall: props.wall,
            start: props.start,
            final: props.final,
            row: props.position.x,
            column: props.position.y,
            closed: props.closed,
            solution: props.solution
        };

    }

    render() {
        const id = this.state.row + "-" + this.state.column;
        let extra = "";

        switch (true) {
            case this.state.wall:
                extra = "square_wall";
                break;
            case this.state.start:
                extra = "square_start";
                break;
            case this.state.final:
                extra = "square_final";
                break;
            case this.state.solution:
                extra = "square_solution";
                break; 
            case this.state.closed:
                extra = "square_closed";
                break;
            default:
                extra = "square_empty";
                break;
        }

        return (
            <div id={id} className={`square ${extra}`} onClick={() => this.props.handleClick()}></div>
        );
    }
}

export default Square;